const HEAVENLY_STEMS = ["甲","乙","丙","丁","戊","己","庚","辛","壬","癸"];
const EARTHLY_BRANCHES = ["子","丑","寅","卯","辰","巳","午","未","申","酉","戌","亥"];

export function getYearGanZhiByPreciseLiChun(dateKey) {
  const date = new Date(dateKey + "T00:00:00Z");
  const year = date.getUTCFullYear();

  const liChunUTC = getPreciseLiChunUTC(year);

  let effectiveYear = year;

  if (date < liChunUTC) {
    effectiveYear = year - 1;
  }

  const baseYear = 1984; // 甲子
  const diff = effectiveYear - baseYear;

  const stemIndex = ((diff % 10) + 10) % 10;
  const branchIndex = ((diff % 12) + 12) % 12;

  return HEAVENLY_STEMS[stemIndex] + EARTHLY_BRANCHES[branchIndex];
}

// ===============================
// ASTRONOMICAL SOLAR LONGITUDE
// ===============================

function toJulian(date) {
  return date / 86400000 + 2440587.5;
}

function fromJulian(jd) {
  return new Date((jd - 2440587.5) * 86400000);
}

function solarLongitude(jd) {
  const T = (jd - 2451545.0) / 36525;
  const L0 = 280.46646 + 36000.76983 * T;
  const M = 357.52911 + 35999.05029 * T;

  const C =
    (1.914602 - 0.004817 * T - 0.000014 * T * T) *
      Math.sin((M * Math.PI) / 180) +
    (0.019993 - 0.000101 * T) *
      Math.sin((2 * M * Math.PI) / 180) +
    0.000289 * Math.sin((3 * M * Math.PI) / 180);

  const trueLong = L0 + C;
  return (trueLong % 360 + 360) % 360;
}

function findSolarTerm(year, targetDegree, approxMonth) {
  let date = new Date(Date.UTC(year, approxMonth, 1));
  let jd = toJulian(date);

  for (let i = 0; i < 30; i++) {
    const lon = solarLongitude(jd);
    if (Math.abs(lon - targetDegree) < 0.5) break;
    jd += (targetDegree - lon) / 360 * 365.25;
  }

  let low = jd - 1;
  let high = jd + 1;

  for (let i = 0; i < 30; i++) {
    const mid = (low + high) / 2;
    const lon = solarLongitude(mid);
    if (lon < targetDegree) low = mid;
    else high = mid;
  }

  return fromJulian((low + high) / 2);
}

export function getPreciseLiChunUTC(year) {
  // 315° = 立春
  return findSolarTerm(year, 315, 1);
}

export function getPreciseLiChunWIB(year) {
  const utc = getPreciseLiChunUTC(year);
  return new Date(utc.getTime() + 7 * 60 * 60 * 1000);
}